// extracted by mini-css-extract-plugin
export default {"ratingBtnToggle":"RatingBtnToggle_ratingBtnToggle__4DBc2"};